import { render } from "./HistorialClienteModal.vue?vue&type=template&id=e4e34232&scoped=true"
import script from "./HistorialClienteModal.vue?vue&type=script&lang=js"
export * from "./HistorialClienteModal.vue?vue&type=script&lang=js"

import "./HistorialClienteModal.vue?vue&type=style&index=0&id=e4e34232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e34232"]])

export default __exports__